import { RootState } from "../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

const empty: string[] = [];

export const selectMyTeamsIds = (state: RootState) =>
  state.auth.user?.teamIds || empty;

export const selectAuthStatus = (state: RootState) => state.auth.status;

export const selectUser = (state: RootState) => state.auth.user;

export const selectDefaultPhoneCountryCode = (state: RootState) =>
  state.auth.user?.defaultPhoneCountryCode || "";

export const selectMyId = (state: RootState) => state.auth.user?.id;

export const selectIsSupportUser = (state: RootState) =>
  state.auth.user?.isSupportUser === true;

// The shared session now belongs to a different user than the one this tab
// loaded, so what it shows is someone else's and its requests get refused.
export const selectSessionChangedElsewhere = (state: RootState) =>
  state.auth.loadedUserId !== null &&
  state.auth.sessionUserId !== null &&
  state.auth.loadedUserId !== state.auth.sessionUserId;

export const selectIsUserOrgAdmin = createSelector(
  selectUser,
  (user) => user?.role === "ORG_ADMIN"
);
